import React from 'react';
import GlTypeIcon from './GlTypeIcon';
import { GlType } from '~/types/account';

interface Props {
  glType?: GlType;
  text?: string | number;
}

const GlTypeLabel = ({ glType, text }: Props) => (
  <>
    <GlTypeIcon code={glType} />
    {text}
  </>
);

export default GlTypeLabel;
